const API_URL = process.env.REACT_APP_PUBLIC_API_URL;

export const PASS_SEC = process.env.REACT_APP_PASS_SEC;

export const COOKIE_PATH = API_URL;

// export const COOKIE_SEC = PASS_SEC;
